<div class="d-flex-center m-t-20" *ngIf="!sale?.ticket" @fadeInOut>
    <img src="assets/images/spinner1.gif" width="70">
</div>
<ng-container *ngIf="sale?.ticket">
    <div class="p-10 p-b-0 hide-print" @fadeInOut>

        <!-- Qr or Barcode -->
        <ng-container *ngIf="actionOption == 1 || actionOption == 2">
            <div *ngIf="wantToRedeem" @fadeInOut id="targetDiv">
                <!-- Qr -->
                <div id="EventTicketQR" class="d-flex-center" [ngClass]="{'disable-code': !sale.ticket?.eventObj?.readyToRedeem}"  *ngIf="!showBarcode">
                    <qrcode [elementType]="'img'" [qrdata]="sale.qrCode + '/' + token" [margin]="-10" [width]="200"></qrcode>
                </div>
                <!-- Barcode -->
                <div class="d-flex-center container-barcode m-b-10" [ngClass]="{'disable-code': !sale.ticket?.eventObj?.readyToRedeem}" *ngIf="showBarcode">
                    <svg id="barcode"></svg>
                </div> 
                <!-- Code and token -->
                <div *ngIf="sale.ticket?.eventObj?.readyToRedeem" class="d-flex-center">
                    <div class="font-14">Código: <b>{{sale.qrCode}}</b></div>
                    <div class="m-l-30">
                        <div class="font-14">Token: <b>{{token}}</b></div>
                        <ngb-progressbar type="primary" height="8px" [value]="currentTokenTimerValue" [max]="currentTokenTimerMax"></ngb-progressbar>
                    </div>
                </div>
                <!-- Time to redeem -->
                <div class="d-flex-center m-t-10" *ngIf="!sale.ticket?.eventObj?.readyToRedeem">
                    <div class="font-12 text-center">
                        Quedan: 
                        <span class="font-14 text-purple" style="letter-spacing: 2px;">{{sale.ticket?.eventObj?.readyToRedeemTimeText}}</span>
                        para que inicie el evento, el día del evento se te habilita el QR.
                    </div>
                </div>
            </div> 
            <!-- Want to redeem? -->
            <ng-container *ngIf="!wantToRedeem"> 
                <div class="d-flex-center m-t-20" style="position: relative;" (click)="onChangeWantToRedeem()">
                    <img src="assets/images/qrblurgivis.png" width="160" style="opacity: 0.5;">
                    <div class="btn-dark-custom" style="position: absolute; top: 42%; width: 140px; padding: 8px 14px !important;">
                        <i class="mdi mdi-eye-outline font-18 mr-2"></i>Ver {{!showBarcode ? 'Qr' : 'Código'}}
                    </div>
                </div>
            </ng-container>
        </ng-container> 
        <!-- Send -->
        <ng-container *ngIf="actionOption == 3">
            <app-send-givi [sale]="sale"></app-send-givi>
        </ng-container>
        <!-- Options -->
        <div class="d-flex-center m-t-20">
            <div class="text-center" (click)="onChangeOption(1)" [ngClass]="actionOption == 1 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-qrcode" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">QR</div>
            </div>
            <div class="text-center m-l-10" (click)="onChangeOption(2)" [ngClass]="actionOption == 2 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-barcode" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">Barras</div>
            </div>
            <!-- Eventos -->
            <ng-container *ngIf="sale.isEvent">
                <ng-container *ngIf="sale.isLite">
                    <!-- * No se puede regalar cuando el evento es Lite -->
                    <div class="text-center m-l-10 btn-action" (click)="onViewTicket(AddToWalletModal)">
                        <i class="mdi mdi-wallet-outline" style="font-size: 24px;"></i>
                        <div class="font-12" style="margin-top: -8px; margin-left: -2px;">
                            Wallet
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!sale.isLite">
                    <div *ngIf="!sale.qrDownloadedAt" class="text-center m-l-10" (click)="onChangeOption(3)" [ngClass]="actionOption == 3 ? 'btn-action-active' : 'btn-action'">
                        <i class="mdi mdi-gift-outline" style="font-size: 24px;"></i>
                        <div class="font-12" style="margin-top: -8px;">Regalar</div>
                    </div>
                    <!-- Solo se puede descarga si se permite -->
                    <div *ngIf="sale.allowDownload && sale.ticket?.eventObj?.readyToDownload" class="text-center m-l-10" (click)="onViewTicket(ticketModal)" [ngClass]="actionOption == 4 ? 'btn-action-active' : 'btn-action'">
                        <i class="mdi mdi-package-down" style="font-size: 24px;"></i>
                        <div class="font-12" style="margin-top: -8px; margin-left: -2px;">
                            Generar
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Pases, Cashless -->
            <ng-container *ngIf="!sale.isEvent">
                <div class="text-center m-l-10" (click)="onChangeOption(3)" [ngClass]="actionOption == 3 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-gift-outline" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px;">Regalar</div>
                </div>
                <!-- Solo se puede descarga si se permite -->
                <!-- <div class="text-center m-l-10" (click)="onChangeOption(4)" [ngClass]="actionOption == 4 ? 'btn-action-active' : 'btn-action'">
                    <i class="mdi mdi-email-send-outline" style="font-size: 24px;"></i>
                    <div class="font-12" style="margin-top: -8px; margin-left: -2px;">
                        Enviar
                    </div>
                </div> -->
            </ng-container>
        </div>
        <!-- Details -->
        <ng-container *ngIf="!showMoreDetails">
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = true">
                <div class="font-14">Más detalles</div>
                <i class="mdi mdi-arrow-down font'18"></i>
            </div> 
        </ng-container>
        <div *ngIf="showMoreDetails" @fadeInOut>
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = false">
                <div class="font-14">Menos detalles</div>
                <i class="mdi mdi-arrow-up font'18"></i>
            </div>
            <!-- Cliente -->
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Regalo para: </div>
                    <div (click)="showGiviNote(sale.transactionNotes, sale.id, sale.customerOwnerId,sale.isExpired)">
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes == null">Agregar Nota</div>
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes != null"
                            [ngStyle]="{'background-color':sale.transactionNotes.color, 'color':'#ffffff'}">
                            {{sale.transactionNotes.note.length > 12? sale.transactionNotes.note.slice(0,9) + '...': sale.transactionNotes.note}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- Event Description -->
            <div *ngIf="sale.ticket?.eventObj?.description" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between font-14">
                    <div class="font-bold">Descripción: </div> 
                    <div>
                        <small *ngIf="!showDescription" class="font-12 m-t-8 font-bold" (click)="showDescription = true" style="text-decoration: underline;">Ver</small>
                        <small *ngIf="showDescription" class="font-12 ml-2 m-t-8 font-bold" (click)="showDescription = false" style="text-decoration: underline;">Ocultar</small>
                    </div>
                </div> 
                <div class="mr-auto text-left" *ngIf="showDescription">
                    <p class="font-12 ml-2" [innerHTML]="sale.ticket?.eventObj?.description"></p>
                </div>
            </div>
            <!-- Ticket Instructions  -->
            <div *ngIf="sale.ticket?.instructions" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Instrucciones: </div>
                    <div class="font-12" [innerHTML]="sale.ticket?.instructions"></div>
                </div>
            </div>
            <!--  Address details  -->
            <div *ngIf="sale.ticket?.eventObj?.addressDetails" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Instrucciones: </div>
                    <div class="font-12">{{sale.ticket?.eventObj?.addressDetails}}</div>
                </div>
            </div>
            <!--  Waze link  -->
            <div *ngIf="sale.ticket?.eventObj?.wazeLink" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Waze: </div>
                    <div class="font-12"> 
                        <a class="font-bold" [href]="sale.ticket?.eventObj?.wazeLink" target="_blank">
                            <u>Lugar del evento</u>
                        </a>
                    </div>
                </div>
            </div>
            <!--  Nombre del ticket  -->
            <div *ngIf="sale.ticket?.productName" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Nombre del ticket: </div>
                    <div class="font-12">{{sale.ticket?.productName}} <i class="mdi mdi-information text-dark" 
                        (click)="infoOpen(sale.ticket?.productName ,sale.ticket?.description)" style="font-size: 14px;"></i>
                    </div>
                </div>
            </div>
            <!--  Price event -->
            <div *ngIf="sale.customer && sale.customerId == sale.customerOwnerId" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Precio: </div>
                    <div *ngIf="sale.total > 0" class="font-12">{{sale.total | currency: sale?.currencySymbol : 'symbol': '1.2'}}</div>
                    <div *ngIf="sale.total <= 0" class="font-12">Gratis</div>

                </div>
            </div>
            <!--  Activo a partir de -->
            <!-- <div *ngIf="sale.customer && !sale.isCashless" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Activo a partir de: </div>
                    <div class="font-12">{{sale.ticket?.eventObj?.startDateAt | date: 'dd/MMMM/yyyy h:mm a'}}</div>
                </div>
            </div> -->
            <!--  Hour event -->
            <div *ngIf="sale.customer && !sale.isCashless && !sale.isPasses" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Hora Fin: </div>
                    <div class="font-12">{{sale.ticket?.eventObj?.endDateAt | date: 'dd/MMMM/yyyy h:mm a'}}</div>
                </div>
            </div>
            <!--  Vencimiento -->
            <div *ngIf="sale.customer && !sale.isCashless" class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Vencimiento: </div>
                    <div class="font-12">{{sale.expirationAt | date: 'dd/MMMM/yyyy h:mm a'}}</div>
                </div>
            </div>
            <!-- Store Names -->
            <div class="border-top p-t-10 m-t-10">
                <app-smart-list-store [stores]="vendorStores"></app-smart-list-store>
            </div>

            <div class="text-center"> 
                <app-delete-transaction [transaction]="sale"></app-delete-transaction>
            </div>
        </div>
    </div>
</ng-container>

<!-- Success Redeemed -->
<ng-container *ngIf="showSuccess">
    <app-redeemed-success (closeSuccess)="onCloseSuccess()"></app-redeemed-success>
</ng-container>

<ng-template #ticketModal let-modal>
    <div class="modal-body" style='background-color: #1A1B27; padding: 0;'>
        <div class="hide-print p-10">
            <button class="close text-white" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10 text-white"></i>
            </button>
        </div>

        <div id="EvenTicketPreview" style='background-color: #1A1B27; padding: 20px 0; border-radius: 16px'>
            <div style='max-width: 260px; margin: auto; background-color: #FFF; border-radius: 16px 10px 0 0; border: 1px solid #D7D7D7;'>
                
                <div style='text-align: center; padding: 8px; border-bottom: 2px dashed #ccc;'>
                    <p style='color: #333333; font-size: 14px; margin: 0;'>{{sale?.ticket?.productName}}</p>
                </div>
        
                <div style='padding-top: 10px; text-align: center; background-color: #FFF; color: #333333;'>
                    <h2 style='color: #333333; font-size: 18px; margin: 0;'>{{sale?.ticket?.evenName}}</h2>
                    
                    <img [src]='sale?.ticket.imageToBase64' style='max-width: 40%; height: auto; margin: 10px 0;'>

                    <div style='background-color: #FFFF; color: #333333; font-size: 14px;'>
                        <p style='text-align: center; color: #333333; font-size: 14px;margin-bottom: 5px;'>
                            <b>
                                <i class="mdi mdi-calendar-outline font-18"></i>
                                Inicio del evento:
                            </b> 
                            <br> {{sale?.ticket.saleDateStartAt | date: 'MMM dd yyyy h:mm a'}}
                        </p>
                        <p *ngIf="sale.ticket?.eventObj?.addressDetails" style='text-align: center; color: #333333; font-size: 14px;margin-bottom: 5px;'>
                            <b>
                                <i class="mdi mdi-map-marker-outline font-18"></i>
                                Lugar del evento:
                            </b> 
                            <br>{{sale.ticket?.eventObj?.addressDetails}}
                        </p>
                        <p style='text-align: center; color: #333333; font-size: 14px;margin: 0;'>
                            <b>
                                <i class="mdi mdi-account-outline font-18"></i>
                                Entrada a nombre de: 
                            </b>
                            <br>{{sale?.customerOwner?.name}}
                        </p>
                    </div>
                </div>
        
                <div style='border-bottom: 2px dashed #ccc; width: 100%; height: 18px;'>
                    <div style='float: left; margin-left: -2px;'>
                        <div style='width: 18px; height: 36px; background-color: #1C1B22; border-radius: 0 100% 100% 0 / 0 50% 50% 0;'></div>
                    </div>
                    <div style='float: right; margin-right: -2px;'>
                        <div style='width: 18px; height: 36px; background-color: #1C1B22; border-radius: 100% 0 0 100% / 50% 0 0 50%;'></div>
                    </div>
                </div>
        
                <div style='text-align: center; background-color: #FFF;'>
                    <qrcode [elementType]="'img'" [qrdata]="sale.qrCodeLite" [margin]="-10" [width]="220"></qrcode>
                </div>
        
                <div style='background-color: #FFF; height: 24px;' >
                    <table style='width: 100%;' cellpadding='10' >
                        <tr>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                            <td><div style='width: 24px; height: 24px; background-color: #1C1B22; border-radius: 50%;'></div></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="d-flex-center hide-print" style="border-top: 1px dashed #ccc;">
            <div class="text-center m-t-10 m-b-15">
                <div class="font-16 text-muted">
                    Tomale un pantallazo para mostrarla <br>el día del evento
                </div>
                <div class="font-16 text-muted">O</div>
                <div class="font-16 text-primary cursor-pointer" (click)="onSendEmailTicket()">Descargar tu entrada</div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #AddToWalletModal let-modal>
    <div class="p-20">
        <div class="d-flex-between">
            <div class="font-16 font-bold">Ticket</div>
            <button class="close" (click)="modal.dismiss()">
                <i class="mdi mdi-window-close font-18 font-bold"></i>
            </button>
        </div>

        <div class="d-flex-between w-100 m-t-20">
            <a [href]="sale.appleWalletUrl" style="width: 49%;" target='_blank'>
                <img src="https://givi-us-east-2.s3.us-east-2.amazonaws.com/givi/emails/AddToAppleWallet.png" style="width: 100%;">
            </a>
            <a [href]="sale.googleWalletUrl" style="width: 49%;" target='_blank'>
                <img src="https://givi-us-east-2.s3.us-east-2.amazonaws.com/givi/emails/AddToGoogleWallet.png" style="width: 100%;">
            </a>
        </div>
        <div class="text-center m-t-20">
            <button class="btn-dark-custom" (click)="onSendEmailTicket()">
                <i class="mdi mdi-email-send-outline"></i> Enviar Ticket por Email
            </button>
        </div>
        <div class="text-center m-t-20">
            <div class="font-14 text-muted cursor-pointer" (click)="modal.dismiss()">Cerrar</div>
        </div>
    </div>
</ng-template>

<app-givi-note-modal [giviNote]="giviNote" [transactionId]="transactionId" [customerOwnerId]="customerOwnerId" [countryNote]="country" (onUpdateNote)="onUpdateNote($event)"></app-givi-note-modal>